import Vue from "vue";
import _ from "lodash";

export const propertiesService = {
  list,
  getById,
  create,
  update
};

function list(params) {
  return Vue.axios.get("v1/properties", { params });
}

function getById(id) {
  return Vue.axios.get(`v1/properties/${id}`);
}

function create(payload) {
  const formData = new FormData();

  payload = _.clone(payload);

  if (payload.price) {
    payload.price = payload.price * 100;
  }

  formData.set("name", payload.name);
  formData.set("description", payload.description);
  formData.set("address", payload.address);
  formData.set("zipcode", payload.zipcode);
  formData.set("price", payload.price);
  formData.set("shareable_url", payload.shareable_url);
  formData.set("tour_url", payload.tour_url);
  formData.set("building_id", payload.building_id);
  formData.set("latitude", payload.latitude);
  formData.set("longitude", payload.longitude);
  formData.set("status", payload.status);
  formData.set("is_visible", !!payload.isVisible);
  formData.set("highlight", !!payload.isHighlight);
  formData.set("highlight_title", payload.highlight_title);
  formData.set("highlight_description", payload.highlight_description);

  payload.images.forEach(image => {
    formData.append("images[]", image);
  });

  payload.feature_ids.forEach(feature_id => {
    formData.append("feature_ids[]", feature_id);
  });

  return Vue.axios.post("v1/properties", formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}

function update(payload) {
  const formData = new FormData();

  payload = _.clone(payload);

  if (payload.price) {
    payload.price = payload.price * 100;
  }

  formData.set("name", payload.name);
  formData.set("description", payload.description);
  formData.set("address", payload.address);
  formData.set("zipcode", payload.zipcode);
  formData.set("price", payload.price);
  formData.set("shareable_url", payload.shareable_url);
  formData.set("tour_url", payload.tour_url);
  formData.set("building_id", payload.building_id);
  formData.set("latitude", payload.latitude);
  formData.set("longitude", payload.longitude);
  formData.set("status", payload.status);
  formData.set("is_visible", !!payload.isVisible);
  formData.set("highlight", !!payload.isHighlight);
  formData.set("highlight_title", payload.highlight_title);
  formData.set("highlight_description", payload.highlight_description);

  if (payload.images.length) {
    payload.images.forEach(image => {
      formData.append("images[]", image);
    });
  }

  if (payload.feature_ids.length) {
    payload.feature_ids.forEach(feature_id => {
      formData.append("feature_ids[]", feature_id);
    });
  } else {
    formData.set("feature_ids[]", []);
  }

  return Vue.axios.patch(`v1/properties/${payload.id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}
